/**
 * @desc 回传paypal
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.TrackersBatchResponse>;
export function request(
  body: defs.basics.TrackersBatchRequest,
  params: API.basics.platformFacadeImpl.paypalTrackersBatch.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paypalTrackersBatch`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
